module.exports = __webpack_public_path__ + "static/img/space-jam-site.8545780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/space-jam-site.png
// module id = o+Ji
// module chunks = 1